export const CREATE_SALE_REPORT_ERROR: Record<string, string> = {
  SalesReportWasteCheckerDataNotFoundError: "ไม่พบข้อมูลการตรวจสอบของเสีย",
  SalesReportCheckinDataNotFoundError: "ไม่พบข้อมูลการเช็คอินของสายส่ง",
  SalesReportSalesDataNotFoundError: "ไม่พบข้อมูลยอดขายของสายส่ง",
  // Backdated create (GDP-1274): a report for this route + report_date already
  // exists. BE error code not finalized yet — likely variants, adjust when confirmed.
  SalesReportAlreadyExistsError: "มีรายงานของสายส่งนี้ในวันที่เลือกอยู่แล้ว",
  DuplicateSalesReportError: "มีรายงานของสายส่งนี้ในวันที่เลือกอยู่แล้ว",
  // Strict YYYY-MM-DD rejected by BE (FE validates before sending; this is a backstop).
  VALIDATION_ERROR: "รูปแบบวันที่ไม่ถูกต้อง (ต้องเป็น YYYY-MM-DD)",
};

// Warnings, not failures: the request SUCCEEDED but shipped something the user has
// to know about. They travel the same channel as errors (`pushGlobalError`) and are
// told apart by this map alone, which is what flips the alert to `severity="warning"`.
export const GLOBAL_WARNING: Record<string, string> = {
  // The Express CSV downloaded fine, but the backend could not reach vansale for the
  // QR payment statuses (timeout / outage), so QRPAY may be blank on rows that were
  // actually paid by QR. Silence here reads as "no QR sales that day" — it is not.
  ExpressQrPaymentUnavailable:
    "ดึงสถานะ QR จากระบบ vansale ไม่สำเร็จ คอลัมน์ QRPAY ในไฟล์อาจไม่ครบ กรุณา Export ใหม่อีกครั้ง",
};
